export const SITE_URL = "https://oopbuyspreadsheets.sbs";